import type { User } from "src/types";
import apiRequest from "src/utils/api-request";
import withApiPath from "src/utils/with-api-path";

export interface Invitation {
	id: number;
	email: string;
	status: "pending" | "accepted" | "expired" | "revoked";
	invitedBy?: User;
	expiresAt: string;
	acceptedAt?: string;
	createdAt: string;
}

export interface ListInvitationsResponse {
	invitations: Invitation[];
}

const invitationProvider = {
	async createInvitation(email: string): Promise<Invitation> {
		const response = await apiRequest.post(withApiPath(`/auth/invitations`), {
			email,
		});
		return response.data;
	},

	async listInvitations(
		limit = 20,
		offset = 0,
	): Promise<ListInvitationsResponse> {
		const response = await apiRequest.get(withApiPath(`/auth/invitations`), {
			params: { limit, offset },
		});
		return response.data;
	},

	async resendInvitation(id: number): Promise<void> {
		await apiRequest.post(withApiPath(`/auth/invitations/${id}/resend`));
	},

	async revokeInvitation(id: number): Promise<void> {
		await apiRequest.post(withApiPath(`/auth/invitations/${id}/revoke`));
	},

	async validateInvitation(
		token: string,
	): Promise<{ email: string; expiresAt: string }> {
		const response = await apiRequest.get(
			withApiPath(`/auth/invitations/validate`),
			{
				params: { token },
			},
		);
		return response.data;
	},

	async acceptInvitation(
		token: string,
		name: string,
		password: string,
	): Promise<User> {
		const response = await apiRequest.post(
			withApiPath(`/auth/invitations/accept`),
			{
				token,
				name,
				password,
			},
		);
		return response.data;
	},
};

export default invitationProvider;
